import { render, staticRenderFns } from "./Yoti.vue?vue&type=template&id=a3d1a636&scoped=true&"
import script from "./Yoti.vue?vue&type=script&lang=js&"
export * from "./Yoti.vue?vue&type=script&lang=js&"
import style0 from "./Yoti.vue?vue&type=style&index=0&id=a3d1a636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d1a636",
  null
  
)

export default component.exports